import React from "react"
import Link from "../../utils/link"
import { Link as UrlLink } from "gatsby"
import { isBrowser } from "../../utils/auth"
import { Formik } from "formik"
import * as Yup from "yup"
import { Button } from "../button/button"
import useFooterIWFSection from "../sectionStaticQuery"
import { getImageAltText } from "../../utils/manipulation"
import Image from "../../images/image"
import { pushToDataLayer } from "../../utils/dataLayer"

function classNames(...classes) {
	return classes.filter(Boolean).join(" ")
}

const navigation = {
	Products: [
		{ name: "Reporter Product Overview", href: "/reporter-overview" },
		{ name: "Reporter Product Features", href: "/reporter-features" },
		{ name: "Reporter for Barracuda", href: "/barracuda" },
		{ name: "Reporter for Cisco Firepower", href: "/ciscofirepower" },
		{ name: "Reporter for Cisco Umbrella SIG", href: "/ciscoumbrella" },
		{ name: "Reporter for ContentKeeper", href: "/contentkeeper" },
		{ name: "Reporter for FortiGate", href: "/fortinet" },
		{ name: "Reporter for Palo Alto Networks", href: "/paloaltonetworks" },
		{ name: "Reporter for Sophos Firewall", href: "/sophos" },
		{
			name: "Reporter for Sophos Web Appliance",
			href: "/sophos/swa",
		},
		{ name: "Reporter for SonicWall", href: "/sonicwall" },
		{ name: "Reporter for TMG", href: "/tmgreporter" },
		{ name: "Reporter for WatchGuard", href: "/watchguard" },
		{ name: "Fastvue Syslog", href: "/syslog" },
		{ name: "WebSpy Vantage", href: "https://www.webspy.com" },
	],
	Solutions: [
		{ name: "Education", href: "/education" },
		{ name: "Business", href: "/business" },
		{ name: "Public Sector", href: "/publicsector" },
		{ name: "IT", href: "/it" },
	],
	Company: [
		{ name: "About us", href: "/about" },
		{ name: "Customers", href: "/customers" },
		{ name: "Partners", href: "/partners" },
		{ name: "Contact", href: "/contact" },
		{ name: "Blog", href: "/blog" },
	],
	Support: [{ name: "Support Center", href: "/contact/support" }],
	Legal: [
		{ name: "Privacy Policy", href: "/legal/privacy-policy" },
		{ name: "Terms of use", href: "/legal/terms" },
		{ name: "Privacy center", href: "/privacy-center" },
		{ name: "Cookie settings", href: "/cookie-settings" },
	],
	social: [
		{
			name: "Facebook",
			href: "https://www.facebook.com/fastvue",
			icon: (props) => (
				<svg
					fill="currentColor"
					viewBox="0 0 24 24"
					{...props}
				>
					<path
						fillRule="evenodd"
						d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
						clipRule="evenodd"
					/>
				</svg>
			),
		},
		{
			name: "Twitter",
			href: "https://www.twitter.com/fastvue",
			icon: (props) => (
				<svg
					fill="currentColor"
					viewBox="0 0 24 24"
					{...props}
				>
					<path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
				</svg>
			),
		},
		{
			name: "GitHub",
			href: "https://www.github.com/fastvue",
			icon: (props) => (
				<svg
					fill="currentColor"
					viewBox="0 0 24 24"
					{...props}
				>
					<path
						fillRule="evenodd"
						d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
						clipRule="evenodd"
					/>
				</svg>
			),
		},
		{
			name: "LinkedIn",
			href: "https://www.linkedin.com/company/fastvue",
			icon: (props) => (
				<svg
					fill="currentColor"
					viewBox="0 0 24 24"
					{...props}
				>
					<g
						fill="none"
						fillRule="evenodd"
					>
						<path d="m0 0h24v24h-24z" />
						<path
							d="m19 3a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2-2v-14a2 2 0 0 1 2-2zm-.5 15.5v-5.3c0-1.8-1.46-3.26-3.26-3.26-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93zm-11.62-9.94a1.686 1.686 0 0 0 0-3.37 1.69 1.69 0 0 0 -1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37h-2.77v8.37z"
							fill="currentColor"
							fillRule="nonzero"
						/>
					</g>
				</svg>
			),
		},
	],
}

const currentYear = new Date().getFullYear()
const subscribe_path = process.env.GATSBY_SUBSCRIBE_URL

export default function Footer() {
	const location = isBrowser && window && window.location.pathname
	const iwfSection = useFooterIWFSection()

	return (
		<footer
			className="bg-gray-800"
			aria-labelledby="footer-heading"
		>
			<h2
				id="footer-heading"
				className="sr-only"
			>
				Footer
			</h2>
			<div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
				<div className="grid grid-cols-1 md:grid-cols-2 md:gap-8 lg:grid-cols-3 ">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 md:col-span-2">
						<div className="md:grid md:grid-cols-1 md:gap-8">
							<div>
								<h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
									Products
								</h3>
								<ul className="mt-4 space-y-4">
									{navigation.Products.map((item) => (
										<li key={item.name}>
											<Link
												to={item.href}
												className="text-base text-gray-300 hover:text-white"
											>
												{item.name}
											</Link>
										</li>
									))}
								</ul>
							</div>
						</div>
						<div className="md:grid md:grid-cols-2 md:gap-8">
							<div className="mt-12 md:mt-0">
								<div>
									<h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
										Solutions
									</h3>
									<ul className="mt-4 space-y-4">
										{navigation.Solutions.map((item) => (
											<li key={item.name}>
												<Link
													to={item.href}
													className="text-base text-gray-300 hover:text-white"
												>
													{item.name}
												</Link>
											</li>
										))}
									</ul>
								</div>
								<div className="mt-12">
									<h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
										Legal
									</h3>
									<ul className="mt-4 space-y-4">
										{navigation.Legal.map((item) =>
											item.href === "/cookie-settings" ? (
												<li
													key={item.name}
													dangerouslySetInnerHTML={{
														__html: `<button class="text-base text-gray-300 text-left hover:text-white hover:cursor-pointer" type="button" style="" onclick="displayPreferenceModal()">
                                  Cookie Settings
                              </button>`,
													}}
												></li>
											) : (
												<li key={item.name}>
													<Link
														to={item.href}
														className="text-base text-gray-300 hover:text-white"
													>
														{item.name}
													</Link>
												</li>
											)
										)}
									</ul>
								</div>
							</div>
							<div>
								<div className="mt-12 md:mt-0">
									<h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
										Support
									</h3>
									<ul className="mt-4 space-y-4">
										{navigation.Support.map((item) => (
											<li key={item.name}>
												<UrlLink
													to={item.href}
													className="text-base text-gray-300 hover:text-white"
													state={{ modal: true, origin: `${location}` }}
												>
													{item.name}
												</UrlLink>
											</li>
										))}
									</ul>
								</div>
								<div className="mt-12">
									<h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
										Company
									</h3>
									<ul className="mt-4 space-y-4">
										{navigation.Company.map((item) => (
											<li key={item.name}>
												<Link
													to={item.href}
													className="text-base text-gray-300 hover:text-white"
												>
													{item.name}
												</Link>
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="mt-8 lg:mt-0 md:col-span-2 lg:col-span-1">
						<h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
							Subscribe to our newsletter
						</h3>
						<p className="mt-4 text-base text-gray-500">
							The latest news, articles, and resources, sent to your inbox weekly.
						</p>
						<Formik
							initialValues={{ email: "" }}
							onSubmit={(values, { setSubmitting, resetForm }) => {
								pushToDataLayer("newsletter_footer_click")
								setSubmitting(true)
								isBrowser && window.open(`${subscribe_path}${values.email}`, "_blank")
								setSubmitting(false)
								resetForm()
							}}
							//********Using Yum for validation********/
							validationSchema={Yup.object().shape({
								email: Yup.string().email("Email is invalid").required("Email is required"),
							})}
						>
							{(props) => {
								const {
									values,
									touched,
									errors,
									isSubmitting,
									handleChange,
									handleBlur,
									handleSubmit,
								} = props
								return (
									<form
										onSubmit={handleSubmit}
										className="mt-4 sm:flex sm:max-w-md"
									>
										<div className="mt-1">
											<label
												htmlFor="email-address"
												className="sr-only"
											>
												Email address
											</label>
											<input
												type="email"
												name="email"
												value={values.email}
												onChange={handleChange}
												onBlur={handleBlur}
												className={classNames(
													errors.firstName &&
														touched.firstName &&
														"focus:ring-red-500 focus:border-red-500",
													"appearance-none min-w-0 w-full bg-white border border-transparent rounded-md py-2 px-4 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white focus:border-white focus:placeholder-gray-400"
												)}
												placeholder="Enter your email"
											/>
											{errors.email && touched.email && (
												<p className="text-sm text-red-600 absolute">{errors.email}</p>
											)}
										</div>

										<div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
											<Button.BaseButton
												buttonStyle="fill"
												size="2xl"
												className="btn btn-fill btn-xl w-full bg-white text-gray-900 font-semibold hover:text-gray-900 hover:bg-white hover:border-gray-900"
												type="submit"
												disabled={isSubmitting}
											>
												{isSubmitting ? <>Submitting...</> : <>Subscribe</>}
											</Button.BaseButton>
										</div>
									</form>
								)
							}}
						</Formik>

						<div className="mt-8">
							<h3 className="text-base font-normal text-gray-400 tracking-wider">
								Fastvue is a proud member of the Internet Watch Foundation.
							</h3>
							<Link
								to="https://www.iwf.org.uk/news-media/news/new-partner-steps-up-to-help-iwf-stop-the-spread-of-child-sex-abuse-imagery-online/"
								className="text-base text-gray-400 hover:text-gray-300 flex w-24"
							>
								<Image
									image={iwfSection}
									alt={getImageAltText(iwfSection)}
									className="h-16 w-24 mt-2 text-gray-400 hover:text-gray-300"
								/>
							</Link>
						</div>
					</div>
				</div>
				<div className="mt-8 border-t border-gray-700 pt-8 md:flex md:items-center md:justify-between">
					<div className="flex space-x-6 md:order-2">
						{navigation.social.map((item) => (
							<a
								key={item.name}
								href={item.href}
								className="text-gray-400 hover:text-gray-300"
							>
								<span className="sr-only">{item.name}</span>
								<item.icon
									className="h-6 w-6"
									aria-hidden="true"
								/>
							</a>
						))}
					</div>
					<p className="mt-8 text-base text-gray-400 md:mt-0 md:order-1">
						&copy; {currentYear} Fastvue Pty Ltd. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	)
}
